export default "__VITE_ASSET__94339691__"